// src/components/insights/Figure.jsx

import { useRef } from "react";
import { getNextFigureNumber } from "./figureCounter";

function Figure({ src, caption, id, variant = "photo" }) {
  const numberRef = useRef(null);

  if (numberRef.current === null) {
    numberRef.current = getNextFigureNumber();
  }

  return (
    <figure
      className={`figure figure-${variant}`}
      id={`fig-${id}`}
    >
      <img src={src} alt={caption} />

      <figcaption className="figure-caption">
        <span className="figure-label">
          Figure {numberRef.current}.
        </span>{" "}
        {caption}
      </figcaption>
    </figure>
  );
}

export default Figure;